export default __webpack_public_path__ + "static/image_activities_s@2x-1ffde8e0c9234d5100c921a515d46a91.jpg";